<template>
  <section class="ShopCenter">
    <b-container>
      <div class="lg-none">
        <ShopNav></ShopNav>
      </div>
    </b-container>
    <router-view></router-view>
  </section>
</template>

<script>
import ShopNav from "../components/shop-nav";
export default {
  components: {
    ShopNav
  }
};
</script>
